import { render, staticRenderFns } from "./RightSideMenu.vue?vue&type=template&id=ee763952&scoped=true"
import script from "./RightSideMenu.vue?vue&type=script&lang=js"
export * from "./RightSideMenu.vue?vue&type=script&lang=js"
import style0 from "./RightSideMenu.vue?vue&type=style&index=0&id=ee763952&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee763952",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee763952')) {
      api.createRecord('ee763952', component.options)
    } else {
      api.reload('ee763952', component.options)
    }
    module.hot.accept("./RightSideMenu.vue?vue&type=template&id=ee763952&scoped=true", function () {
      api.rerender('ee763952', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Decoration/PageDecoration/RightSideMenu.vue"
export default component.exports